import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {useTable, useSortBy} from 'react-table';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from '../../api/apiClient';
import {token, domain} from '../Security';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DoneIcon from '@mui/icons-material/Done';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from "@mui/icons-material/Close";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { OvertimeTypeSelect } from '../../common/selectComponents/OvertimeTypeSelect';

function MassApproval({user, isHideSideMenu}) {
    var headerForOvertimeList = [
        "Employee Id",
        "Employee",
        "Date",
        "Hours",
        "Type",
        "Status",
        "",
    ]
    var accessorForOvertimeList = [
        "employeePersonalInformationId",
        "employeePersonalInformationFullName",
        "date",
        "hours",
        "overtimeType",
        "status",
        "manage"
    ]

    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    const [showDeleteAll, setShowDeleteAll] = useState(false);
    const [showPostStagingConfirmationForm, setShowPostStagingConfirmationForm] = useState(false);
    
    const [filterDataIndexForOvertimeList, setFilterDataIndexForOvertimeList] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Employee Name");
    const [overtimeRequestDataForOvertimeList, setOvertimeRequestDataForOvertimeList] = useState([]);
    const [filterDataForOvertimeList, setFilterDataForOvertimeList] = useState([]);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const [selectedToAdd, setSelectedToAdd] = useState([]);
    const handleFilterForOvertimeList = (value) => {
        setCurrentPage(1);

        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndexForOvertimeList) {
            case 0:
                res = filterDataForOvertimeList.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                setSearchPlaceholder("employee name");
                break;
            case 1:
                res = filterDataForOvertimeList.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                setSearchPlaceholder("employee name");
                break;
            case 2:
                res = filterDataForOvertimeList.filter((f) =>
                f.employeePersonalInformationId.toString().startsWith(value)
                );
                setSearchPlaceholder("employee id");
                break;
            default:
                res = filterDataForOvertimeList.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                setSearchPlaceholder("employee name");
                
                break;
        }

        setOvertimeRequestDataForOvertimeList(res);
    };

    const fetchDataForEmployee = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/single-data";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForEmployeesPerTimeKeeper = useCallback(async () => {
        const apiUrl =  domain + `/api/Employee/employee-schedules/timekeeper/${user.employeePersonalInformationId}`;

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);
    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/OvertimeRequestStaging";

        try{
            setLoading(true);
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            const employeesPerTimeKeeper = await fetchDataForEmployeesPerTimeKeeper();
            const timeKeeperIds = employeesPerTimeKeeper.map(emp => emp.employeePersonalInformationId);

            // Filter response.data based on timeKeeperIds
            const filteredData = response.data.filter(data =>
                timeKeeperIds.includes(data.employeePersonalInformationId)
            );
            
            // console.log('Final bulkData:', JSON.stringify(filteredData, null, 2));

            // Update states with filtered data
            setOvertimeRequestDataForOvertimeList(filteredData);
            setFilterDataForOvertimeList(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [fetchDataForEmployeesPerTimeKeeper]);

    useEffect(()=>{
        fetchData();
    }, [fetchData])

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('Template');

        const employeesPerTimeKeeper = await fetchDataForEmployeesPerTimeKeeper();

        const header = [
            'EmployeeId',
            'EmployeeName',
            'Date',
            'Hours',
            'Type',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'employeeName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'hours', width: 30 },
            { key: 'type', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        employeesPerTimeKeeper.forEach(info => {
            const information = {
                    employeeId: info.employeeId,
                    employeeName: info.employeeFullName,
                    date: '<mm/dd/yyyy>',
                    hours: '<2.00>',
                    type: 'Regular',
            };

            worksheet1.addRow(information);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Mass_Approval_Template.xlsx');
    }, [fetchDataForEmployeesPerTimeKeeper]);

    const convertToDateTime = (value) => {
        if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
            return null;
        }

        if(!value){
            return null;
        }

        if (typeof value === 'number') {
            // Convert Excel serial number to JavaScript Date
            const excelStartDate = new Date(1899, 11, 31); // Correct base date
            const jsDate = new Date(excelStartDate.getTime() + value * 86400000); // Convert days to milliseconds
            
            return jsDate.toISOString().split('T')[0];
        }

        if (typeof value === 'string') {
            let formattedValue = value.replace(/-/g, '/'); // Ensure compatibility
            
            const parts = formattedValue.split('/');
            if (parts.length === 3) {
                let [first, second, third] = parts.map(p => parseInt(p, 10));
    
                let year, month, day;
    
                if (third > 31) {
                    // Case: YYYY/MM/DD (Ensure proper year detection)
                    year = third;
                    month = first;
                    day = second;
                } else if (first > 12) {
                    // Case: DD/MM/YYYY (Auto-detect)
                    day = first;
                    month = second;
                    year = third;
                } else {
                    // Case: MM/DD/YYYY (US format)
                    month = first;
                    day = second;
                    year = third;
                }
    
                return new Date(Date.UTC(year, month - 1, day)).toISOString().split('T')[0]; // Return YYYY-MM-DD
            }
        }

        return null
    }

    const [uploadData, setUploadData] = useState([])
    const uploadEmployeeData = async (file) => {
        setLoadingUploadRequest(true);
        const dataEmployee = await fetchDataForEmployee();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }
        function sanitizeValueInteger(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 0;
            }
            return parseFloat(value);
        }
        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                if (!item.employeeId) missing.push('Employee Id');
                if (!item.date) missing.push('Date');
                if (!item.hours) missing.push('Hours');
                if (!item.overtimeType) missing.push('Type');
        
                // ✅ Construct error message properly
                let errorMessage = "";

                const existingEmployee = dataEmployee.find(employee => employee.employeeId === item.employeeId?.toString());
                if (!existingEmployee) {
                    errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
                }

                if (isNaN(item.hours)) {
                    errorMessage += errorMessage.length > 0 ? ` Invalid value - Hours.` : `Invalid value - Hours. `;
                }
        
                if (missing.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];
    
            informations.forEach(info => {
                let foundEmployee = null;

                foundEmployee = dataEmployee.find(data => data.employeeId.toLowerCase() === sanitizeValue(info.EmployeeId).toString().toLowerCase());

                // i will use the locations, employments etc. here below
                bulkData.push({
                    employeeId: sanitizeValue(info.EmployeeId),
                    fullName: sanitizeValue(info.EmployeeName),
                    employeePersonalInformationId: foundEmployee ?
                                sanitizeValue(foundEmployee.id)
                                :
                                0,
                    date: convertToDateTime(info.Date),
                    hours: sanitizeValueInteger(info.Hours),
                    overtimeType: sanitizeValue(info.Type),
                    dateRequested: new Date(),
                    status: "Sent",
                    requestTypeId: 3, // 3 is Overtime Request
                    approverId: null,
                    reason: "",
                    reasonForRejection: "",
                    hasOvertimeAllowance: false,
                    isAboveTwoHoursOvertime: false,
                    content: ""
                });
            });

            // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            // Validate the bulk data
            const validatedData = validateData(bulkData);
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors.length > 0;
                const hasErrorB = b.errors && b.errors.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });
            setUploadData(sortedData)

            /* if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
        
                const errorMessages = validation.message.split('\n').filter(line => line);
        
                if (errorMessages.length > 10) {
                    // Export to Excel
                    const workbook = XLSX.utils.book_new();
                    const worksheetData = [["Row", "Error Message"]];
        
                    errorMessages.forEach((message, index) => {
                        worksheetData.push([`Row ${index + 1}`, message]);
                    });
        
                    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Errors");
        
                    XLSX.writeFile(workbook, "errorFile.xlsx");
                } else {
                    // Display the messages directly
                    setRequestMessage(errorMessages.map((line, index) => (
                        <div key={index}>{line}</div>
                    )));
                }
            }

            const upload = async (data) => {
                const apiUrl = `${domain}/api/OvertimeRequestStaging/bulk`;
            
                try {
                    const response = await axios.post(apiUrl, data, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    
                    await fetchData();
                    setLoadingRequest(false);
                    setRequestMessage('Upload successful');
                    setShowRequestMessage(true);
                    setIsSuccess(true);
                    console.log('Upload successful:', response.data);
                } catch (error) {
                    setLoadingRequest(false);
                    setShowRequestMessage(true);
                    setIsSuccess(false);
                    console.error('Error:', error);
                    const errorMessage = error.response?.data?.message || 'An error occurred';
                    setRequestMessage(errorMessage);
                }
            }

            upload(bulkData); */
            
            /* const handleBulkUpload = async () => {
                try {
                    await Promise.all(bulkData.map(data => upload(data)));
                    await fetchData();
                    setLoadingRequest(false);
                    setRequestMessage('Upload successful');
                    setShowRequestMessage(true);
                    setIsSuccess(true);
                } catch (error) {
                    setLoadingRequest(false);
                    setShowRequestMessage(true);
                    setIsSuccess(false);
                    console.error('Error:', error);
                    const errorMessage = error.response?.data?.message || 'An error occurred';
                    setRequestMessage(errorMessage);
                }
            }
            
            handleBulkUpload(); */
        };
    
        setLoadingUploadRequest(false);
        reader.readAsArrayBuffer(file);
    };
    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }
    const handleFinalFileUpload = async (bulkData) => {
        setLoadingRequest(true)
        const apiUrl = `${domain}/api/OvertimeRequestStaging/bulk`;
            
        try {
            const response = await axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await fetchData();
            setLoadingRequest(false);
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Upload successful:', response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false)
        }
    }

    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }

    const fetchDataApproverHierarchy = useCallback(async () => {
        const apiUrl =  domain + "/api/ApproverHierarchy";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataEmployees = useCallback(async (id) => {
        const apiUrl = domain +"/api/Employee";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const getApproverContact = async (myApprover, employeesInfo) =>{
        const formatPhoneNumber = (number) => {
            // Remove all dashes
            const cleanedNumber = number.replace(/-/g, '');
        
            // Check if the number starts with '0' and remove it
            const formattedNumber = cleanedNumber.startsWith('0') 
                ? '+63' + cleanedNumber.slice(1) 
                : '+63' + cleanedNumber;
        
            return formattedNumber;
        };
        
        let approverNumbers = [];

        if(myApprover.primaryApprover){
            if(myApprover.primaryApprover.primaryApprover1Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover1Id,
                        fullName: myApprover.primaryApprover.primaryApprover1FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover2Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover2Id,
                        fullName: myApprover.primaryApprover.primaryApprover2FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover3Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover3Id,
                        fullName: myApprover.primaryApprover.primaryApprover3FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover4Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover4Id,
                        fullName: myApprover.primaryApprover.primaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.secondaryApprover){
            if(myApprover.secondaryApprover.secondaryApprover1Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover1Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover1FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover2Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover2Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover2FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover3Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover3Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover3FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover4Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover4Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.tertiaryApprover){
            if(myApprover.tertiaryApprover.tertiaryApprover1Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover1Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover1FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover2Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover2Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover2FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover3Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover3Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover3FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover4Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover4Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover4FullName
                    });
                }
            }
        }

        return approverNumbers;
    };
    const sendSmsBulk = async (smsData) => {
        try {
            const response = await axios.post('http://161.49.93.114:8081/api/Sms/send-sms-bulk', smsData); // euro asia
            // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms-bulk', smsData); // my server
            console.log(response, `SMS request sent successfully.`);
        } catch (error) {
            console.error(`Error sending SMS request`, error);
        }
    };

    const handlePostStaging = async () => {
        const apiUrl = `${domain}/api/OvertimeRequestStaging/post-staging`;
        setLoadingRequest(true);
        closePostStagingConfirmationHandleClick();

        const approverHierarchies = await fetchDataApproverHierarchy();
        const employeesInfo = await fetchDataEmployees();
    
        try {
            const response = await axios.post(apiUrl, overtimeRequestDataForOvertimeList, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();

            let requestsToBeSent = [];

            for (let i = 0; i < overtimeRequestDataForOvertimeList.length; i++) {
                const formattedNumber = overtimeRequestDataForOvertimeList[i].referenceNumber.toString().padStart(6, '0');
                const approver = approverHierarchies.find(data => data.employeePersonalInformationId === overtimeRequestDataForOvertimeList[i].employeePersonalInformationId);
                const contacts = await getApproverContact(approver, employeesInfo);

                if(contacts.length <= 0){
                    continue;
                }

                const composeMessage = 
`Hello,

${overtimeRequestDataForOvertimeList[i].employeePersonalInformationFullName} filed an Overtime Request. 

Please check reference number OT-${formattedNumber} in the portal.`
;

                for (const contact of contacts) {
                    const smsData = {
                        requestTypeId: 3,
                        date: new Date(),
                        senderId: overtimeRequestDataForOvertimeList[i].employeePersonalInformationId,
                        senderFullName: overtimeRequestDataForOvertimeList[i].employeePersonalInformationFullName,
                        message: composeMessage,
                        recipientId: contact.id,
                        recipientFullName: contact.fullName,
                        recipientMobileNumber: contact.phoneNumber // phoneNumber
                    }

                    requestsToBeSent.push(smsData);
                }
            }

            if(requestsToBeSent.length > 0){
                await sendSmsBulk(requestsToBeSent);
            }

            setLoadingRequest(false);
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Post successful:', response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        }

        setLoadingRequest(false);
    }
    const openPostStagingConfirmationHandleClick  = () =>{
        setShowPostStagingConfirmationForm(true);
    }
    const closePostStagingConfirmationHandleClick = () =>{
        setShowPostStagingConfirmationForm(false);
    }

    const handleDeleteAll = async () => {
        const apiUrl = `${domain}/api/OvertimeRequestStaging/bulk-delete`;
        setLoadingRequest(true);
        closeDeleteAll();
    
        try {
            const response = await axios.delete(apiUrl, {
                data: overtimeRequestDataForOvertimeList,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setLoadingRequest(false);
            setRequestMessage('Delete successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Delete successful:', response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        }

        setLoadingRequest(false);
    }
    const openDeleteAll = () =>{
        setShowDeleteAll(true);
    }
    const closeDeleteAll = () =>{
        setShowDeleteAll(false);
    }

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [overtimeType, setOvertimeType] = useState("");
    const [date, setDate] = useState("");
    const [hours, setHours] = useState("");

    const [selectedData, setSelectedData] = useState(null);
    const [showEditForm, setShowEditForm] = useState(false);
    const openEditForm = (data) => {
        setShowEditForm(true);
        setSelectedData(data);
    }
    const closeEditForm = () => {
        setShowEditForm(false);
        setSelectedData(null);
    }
    useEffect(() => {
        if(showEditForm){
            setEmployeePersonalInformationId(selectedData.employeePersonalInformationId);
            setEmployeePersonalInformationFullName(selectedData.employeePersonalInformationFullName);
            setOvertimeType(selectedData.overtimeType);
            setDate(selectedData.date);
            setHours(selectedData.hours);
        }
    }, [showEditForm, selectedData])
    const updateRequest = async (event) => {
        event.preventDefault();
        setLoadingRequest(true);

        const apiUrl =  domain + "/api/OvertimeRequestStaging";

        let data = {
            employeePersonalInformationId: employeePersonalInformationId, //temporary
            requestTypeId: selectedData.requestTypeId,
            reason: selectedData.reason,
            reasonForRejection: selectedData.reasonForRejection,
            status: selectedData.status,
            dateRequested: selectedData.dateRequested,
            dateCompleted: selectedData.dateCompleted,
            content: selectedData.content,
            date: date,
            hours: hours,
            overtimeType: overtimeType,
        };

        
        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            const reponse = await axios.put(apiUrl + `/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Data updated successfully', reponse.data);
            
            closeEditForm();

            // Reload table data and reset form fields
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            setRequestMessage("Request Successful");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const openDeleteForm = (data) => {
        setShowDeleteForm(true);
        setSelectedData(data);
    }
    const closeDeleteForm = () => {
        setShowDeleteForm(false);
        setSelectedData(null);
    }
    const handleDelete = async () => {
        const apiUrl = `${domain}/api/OvertimeRequestStaging/delete/${selectedData.id}`;
        setLoadingRequest(true);
        closeDeleteForm();
    
        try {
            const response = await axios.delete(apiUrl, {
                data: overtimeRequestDataForOvertimeList,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setLoadingRequest(false);
            setRequestMessage('Delete successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Delete successful:', response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        }

        setLoadingRequest(false);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo shadow-xl">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                    <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                    <span style={{borderBottom:"1px solid black"}}>{"Mass Approval"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Mass Approval</h3>
                                <div style={{width:"30%",textAlign:"right"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            openPostFormHandleClick={openPostStagingConfirmationHandleClick}
                                            openDeleteAll={openDeleteAll}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="transaction-body">
                            <div className='loan-tab overtimelist'>
                                <div>
                                    <div style={{padding:"20px 0"}}>
                                        {FilterForOvertimeList(setFilterDataIndexForOvertimeList)}
                                        <div className="transaction-body-top row">
                                            {CreateSearchBarWithPlaceHolder("", 
                                                                            "transaction-search row", 
                                                                            "transaction-search-icon", 
                                                                            "transaction-search-input", 
                                                                            (e)=>handleFilterForOvertimeList(e.target.value), 
                                                                            `Search by ${searchPlaceholder}`,
                                                                            SearchIcon)}
                                            <div className="transaction-addBtn row" style={{display:"none"}}>
                                                {CreateButton("", "approve row", "handleConfirmationApproveFromOvertimeList", "APPROVE", DoneIcon)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="transaction-table container">
                                        <CreateTableForOvertimeList
                                            dataList={overtimeRequestDataForOvertimeList}
                                            dataHeader={headerForOvertimeList}
                                            dataAccessor={accessorForOvertimeList}
                                            selectedToAdd={selectedToAdd} 
                                            setSelectedToAdd={setSelectedToAdd}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            openEditForm={openEditForm}
                                            openDeleteForm={openDeleteForm}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditOTForm  isOpen={showEditForm} 
                    onClose={closeEditForm}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    employeePersonalInformationId={employeePersonalInformationId}
                    overtimeType={overtimeType}
                    date={date}
                    hours={hours}setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setOvertimeType={setOvertimeType}
                    setHours={setHours}
                    setDate={setDate}
                    handleUpdate={updateRequest}
            >
            </EditOTForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteForm}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    data_temp={uploadData}
                    setData_temp={setUploadData}
                    handleFileUpload={handleFileUpload}
                    handleFinalFileUpload={handleFinalFileUpload}
            >
            </UploadForm>
            <ConfirmationPostForm  isOpen={showPostStagingConfirmationForm} 
                        onClose={closePostStagingConfirmationHandleClick}
                        handleConfirm={handlePostStaging}
            >
            </ConfirmationPostForm>
            <DeleteAllForm  isOpen={showDeleteAll} 
                    onClose={closeDeleteAll}
                    handleDelete={handleDeleteAll}
            >
            </DeleteAllForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "10000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
            {loadingUploadRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "10000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function SettingInit({
    generateDownloadTemplate,
    openUploadFormHandleClick,
    openPostFormHandleClick,
    openDeleteAll
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Overtime Request/s
            </div>
            <div className="payroll-setting-item row"onClick={()=>openDeleteAll()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><DeleteSweepIcon/></div>
                Delete All Requests
            </div>
            <div className="payroll-setting-item row"onClick={()=>openPostFormHandleClick()}>
            <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><PostAddIcon/></div>
                Post Overtime Request/s
            </div>
        </div>
    )
}
function CreateTableForOvertimeList({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    setSelectedEmployee ,
    selectedToAdd,
    setSelectedToAdd,
    currentPage, setCurrentPage,
    openEditForm,
    openDeleteForm
}) {
    // const [currentPage, setCurrentPage] = useState(1);
    // const [activeRowId, setActiveRowId] = useState(null);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // const handleRowClick = (rowData) => {
    //     setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
    //     setActiveRowId(rowData.id);
    // };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            // onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                            // className={row.original.id === activeRowId ? 'active' : ''}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfoForOvertimeList header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            selectedToAdd={selectedToAdd} 
                                            setSelectedToAdd={setSelectedToAdd}
                                            openEditForm={openEditForm}
     openDeleteForm={openDeleteForm}
                                    />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForOvertimeList({
    header, 
    _cell,
    selectedToAdd,
    setSelectedToAdd,
    openEditForm,
    openDeleteForm
}) {
    const data = _cell.render("Cell").props.row.original;
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        setIsChecked(data.status === "Approved");
    }, [data]);

    const handleItem = (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);

        if (checked) {
            setSelectedToAdd(prevItems => [...prevItems, data]);
        } else {
            setSelectedToAdd(prevItems => prevItems.filter(i => i !== data));
        }
    };

    if(header === "Approve"){
        return (
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={isChecked}
                    onChange={handleItem}
                    // disabled={data.status !== "Sent" && data.status !== "Pending" }
                    disabled
                />
            </td>
        )
    }

    if(header === "Type"){
        const value = _cell.render("Cell").props.value;

        function formatString(str) {
            const formattedStr = str.replace(/([A-Z])/g, ' $1').trim();
            
            return formattedStr.split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        }
        
        return(
            <td>
                {formatString(value)}
            </td>
        )
    }

    if(header === "Status"){
        const value = _cell.render("Cell").props.value;

        if(value === "Sent"){
            return(
                <td>
                    {"Pending"}
                </td>
            )
        } 
        
        return(
            <td>
                {value}
            </td>
        )
    }

    if(header === "Date"){
        const date = new Date(data.date);

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>openEditForm(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>openDeleteForm(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function FilterForOvertimeList(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeName":
                setFilterDataIndex(1);
                break;
            case "EmployeeId":
                setFilterDataIndex(2);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeName">Employee Name</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function UploadForm({isOpen, 
    onClose,
    data_temp,
    setData_temp,
    handleFileUpload,
    handleFinalFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setData_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(data_temp.length > 0){
            const _errorData = data_temp.filter(i => i.errors.length > 0)

            if(_errorData.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [data_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setData_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUpload(data_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Employee Id",
        "Employee",
        "Date",
        "Hours",
        "Type",
        "Error",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "date",
        "hours",
        "overtimeType",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Approval"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={data_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function ConfirmationPostForm({isOpen, 
    onClose, 
    handleConfirm}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Post Staging Confirmation</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to post the overtime requests?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleConfirm}
                            style={{marginRight:"5px"}}>
                                POST
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteAllForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete All!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete all requests?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditOTForm({isOpen, 
    onClose, 
    employeePersonalInformationFullName, 
    employeePersonalInformationId,
    overtimeType, 
    date, 
    hours, 
    setEmployeePersonalInformationFullName,
    setEmployeePersonalInformationId,
    setOvertimeType,
    setHours,
    setDate,
    handleUpdate,
})
{
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullName"
                                placeholder="Employee"
                                value={employeePersonalInformationFullName}
                                onChange={(e) => setEmployeePersonalInformationFullName(e.target.value)}
                                style={{cursor:"not-allowed"}}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Overtime Type</div>
                            <div className="info-item-input">
                                {/* {OvertimeTypeSelect(overtimeType, setOvertimeType, false)} */}
                                <OvertimeTypeSelect overtimeType={overtimeType} setOvertimeType={setOvertimeType} />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date</div>
                                <div className="info-item-input">
                                    {DateTimeInput(date, setDate, false)}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Hours</div>
                                <div className="info-item-input">
                                    <input
                                    type='number'
                                    id="hours"
                                    placeholder="Hours"
                                    value={hours}
                                    onChange={(e) => setHours(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            style={{marginRight: "5px"}}
                            onClick={handleUpdate}>
                                Update
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this requests?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
// function OvertimeTypeSelect({overtimeType, setOvertimeType, isView}){
//     const [isSelected, setIsSelected] = useState(false);
    
//     const handleSelectChange = (event) => {
//         setIsSelected(true);
//         setOvertimeType(event.target.value);
//     };

//     useEffect(() => {
//         if(overtimeType !== ""){
//             setIsSelected(true);
//         } else {
//             setIsSelected(false);
//         }
//     }, [overtimeType]);

//     return (
//         <div>
//             <select id="employee-select-PagibigReport" disabled={isView} value={overtimeType} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
//             <option value="" disabled hidden>Choose overtime type</option>
//             <option value="Regular">Regular</option>
//             <option value="Restday">Restday</option>
//             <option value="SpecialHoliday">Special Holiday</option>
//             <option value="RegularHoliday">Regular Holiday</option>
//             <option value="RestdaySpecialHoliday">Restday Special Holiday</option>
//             <option value="RestdayRegularHoliday">Restday Regular Holiday</option>
//             </select>
//         </div>
//     );
// };
function DateTimeInput(date, setDate, isView) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            readOnly={isView}
            type="datetime-local"
            id={"datetime-"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function CreateTableForUpload({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [],
    currentPage, setCurrentPage,
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                className={row.original.error ? "error" : ""}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForUpload header={cell.render("Cell").props.column.Header}
                                        _cell={cell}
                                        />
                                    ))}
                                </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForUpload({header, 
    _cell, 
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if(data.photo){
            const imageSrc = 'data:image/jpeg;base64,' + data.photo;

            return(
                <td>
                    <img className="avatarImg" src={imageSrc} alt=""/>
                </td>
            )
        }
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if(header === "Date Created"
    ){
        if(!value){
            return (
                <td>
                </td>
            );
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if(header === "Error"
    ){
        return (
            <td>
                {value && (
                    <p style={{ color: "red", margin: 0 }}>
                        {value}
                    </p>
                )}
            </td>
        );
    }

    if( header === "Vacation Leave"
    || header === "Sick Leave"
    || header === "Service Incentive Leave"
    || header === "Solo Parent Leave"
    || header === "Vacation Leave Remaining"
    || header === "Sick Leave Remaining"
    || header === "Service Incentive Leave Remaining"
    || header === "Solo Parent Leave Remaining"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}

export default MassApproval
